/* ============================================================
   Compare Products — Symmetry 7.3.0
   - Self-contained slider (arrows + pagination dots)
   - Variant popup with swatch selection
   - AJAX add-to-cart that updates the header count + cart drawer
     and opens the drawer, without a page reload.
   ============================================================ */
(function () {
  'use strict';

  var CART_ADD_URL =
    (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add';

  /* ---------- Money helper (best effort) ---------- */
  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
    } catch (e) { /* noop */ }
    return null;
  }

  /* ---------- AJAX add to cart ---------- */
  function addToCart(variantId, button) {
    var sections = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(Boolean);
    var sectionIds = sections.map(function (el) { return el.dataset.sectionId; }).filter(Boolean);

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (sectionIds.length) {
      body.append('sections', sectionIds.join(','));
      body.append('sections_url', window.location.pathname);
    }

    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
    }

    return fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            throw new Error(data.description || data.message || 'Unable to add to cart');
          }
          return data;
        });
      })
      .then(function (data) {
        // Update header (cart count) and cart drawer in place.
        if (data.sections) {
          sections.forEach(function (el) {
            var html = data.sections[el.dataset.sectionId];
            if (html && typeof el.updateFromCartChange === 'function') {
              el.updateFromCartChange(html);
            }
          });
        }
        // Open the cart drawer (works regardless of merchant's after-add setting).
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));

        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-success');
          setTimeout(function () {
            button.classList.remove('is-success');
            button.removeAttribute('aria-disabled');
          }, 1600);
        }
        return data;
      })
      .catch(function (err) {
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
        }
        throw err;
      });
  }

  /* ---------- Variant popup ---------- */
  function VariantPopup(popup) {
    this.popup = popup;
    this.box = popup.querySelector('.compare-popup__box');
    this.addBtn = popup.querySelector('[data-cp-add]');
    this.priceEl = popup.querySelector('[data-cp-popup-price]');
    this.errorEl = popup.querySelector('[data-cp-error]');
    this.swatches = Array.prototype.slice.call(popup.querySelectorAll('[data-cp-swatch]'));
    this.optionNameEls = Array.prototype.slice.call(popup.querySelectorAll('.compare-popup__option-name'));
    this.opener = null;

    var dataEl = popup.querySelector('[data-cp-variants]');
    try {
      this.variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      this.variants = [];
    }
    // Number of options = length of any variant's options array.
    this.optionCount = this.variants.length ? this.variants[0].options.length : 0;

    this.bind();
    this.update();
  }

  VariantPopup.prototype.bind = function () {
    var self = this;

    this.popup.querySelectorAll('[data-cp-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.close(); });
    });

    this.swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var pos = sw.getAttribute('data-option-position');
        self.popup
          .querySelectorAll('[data-option-position="' + pos + '"]')
          .forEach(function (other) {
            other.classList.remove('is-selected');
            other.setAttribute('aria-checked', 'false');
          });
        sw.classList.add('is-selected');
        sw.setAttribute('aria-checked', 'true');
        self.update();
      });
    });

    this.addBtn.addEventListener('click', function () {
      var id = self.addBtn.getAttribute('data-variant-id');
      if (!id || self.addBtn.disabled) return;
      self.hideError();
      addToCart(id, self.addBtn)
        .then(function () { self.close(); })
        .catch(function (err) { self.showError(err.message); });
    });
  };

  VariantPopup.prototype.getSelected = function () {
    var selected = [];
    for (var i = 1; i <= this.optionCount; i++) {
      var active = this.popup.querySelector(
        '[data-option-position="' + i + '"].is-selected'
      );
      selected.push(active ? active.getAttribute('data-value') : null);
    }
    return selected;
  };

  VariantPopup.prototype.findVariant = function (selected) {
    return this.variants.find(function (v) {
      return v.options.every(function (opt, idx) { return opt === selected[idx]; });
    });
  };

  VariantPopup.prototype.update = function () {
    var selected = this.getSelected();
    this.renderOptionNames(selected);

    // Mark swatches whose value yields no available variant (given other choices).
    var self = this;
    this.swatches.forEach(function (sw) {
      var pos = parseInt(sw.getAttribute('data-option-position'), 10) - 1;
      var test = selected.slice();
      test[pos] = sw.getAttribute('data-value');
      var match = self.variants.find(function (v) {
        return v.options.every(function (opt, idx) {
          return test[idx] == null || opt === test[idx];
        });
      });
      var anyAvailable = self.variants.some(function (v) {
        return v.available && v.options[pos] === sw.getAttribute('data-value');
      });
      sw.classList.toggle('is-unavailable', !match || !anyAvailable);
    });

    var variant = this.findVariant(selected);

    if (!variant) {
      this.addBtn.disabled = true;
      this.setLabel('Unavailable');
      return;
    }

    this.addBtn.setAttribute('data-variant-id', variant.id);

    if (variant.available) {
      this.addBtn.disabled = false;
      this.setLabel(this.addBtn.getAttribute('data-default-label') || null);
    } else {
      this.addBtn.disabled = true;
      this.setLabel('Sold out');
    }

    this.renderPrice(variant);
  };

  VariantPopup.prototype.renderOptionNames = function (selected) {
    this.optionNameEls.forEach(function (el, idx) {
      if (selected[idx]) el.textContent = selected[idx];
    });
  };

  VariantPopup.prototype.renderPrice = function (variant) {
    if (!this.priceEl) return;
    var current = variant.price_formatted || formatMoney(variant.price) || '';
    var html = '<span class="compare-popup__price-current">' + current + '</span>';
    // Show strikethrough compare-at price when the variant is on sale.
    if (variant.compare_at && variant.compare_at > variant.price && variant.compare_at_formatted) {
      html += ' <s class="compare-popup__price-was">' + variant.compare_at_formatted + '</s>';
    }
    this.priceEl.innerHTML = html;
  };

  VariantPopup.prototype.setLabel = function (text) {
    var label = this.addBtn.querySelector('.compare-card__atc-label');
    if (!label) return;
    if (!this.addBtn.getAttribute('data-default-label')) {
      this.addBtn.setAttribute('data-default-label', label.textContent);
    }
    label.textContent = text || this.addBtn.getAttribute('data-default-label');
  };

  VariantPopup.prototype.open = function (opener) {
    this.opener = opener || null;
    this.popup.hidden = false;
    // force reflow so the transition runs
    void this.popup.offsetWidth;
    this.popup.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var firstSwatch = this.popup.querySelector('.compare-popup__swatch');
    (firstSwatch || this.addBtn).focus();
  };

  VariantPopup.prototype.close = function () {
    var self = this;
    this.popup.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { self.popup.hidden = true; }, 260);
    if (this.opener) this.opener.focus();
  };

  VariantPopup.prototype.showError = function (msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg || 'Something went wrong. Please try again.';
    this.errorEl.hidden = false;
  };

  VariantPopup.prototype.hideError = function () {
    if (this.errorEl) this.errorEl.hidden = true;
  };

  /* ---------- Slider (arrows + dots) ---------- */
  function Slider(section) {
    this.section = section;
    this.carousel = section.querySelector('[data-cp-carousel]');
    this.slider = section.querySelector('[data-cp-slider]');
    this.dotsWrap = section.querySelector('[data-cp-dots]');
    this.prevBtn = section.querySelector('[data-cp-prev]');
    this.nextBtn = section.querySelector('[data-cp-next]');
    this.showArrows = section.getAttribute('data-show-arrows') !== 'false';
    this.showDots = section.getAttribute('data-show-dots') !== 'false';
    if (!this.slider) return;

    this.bind();
    this.layout();
  }

  Slider.prototype.step = function () {
    var card = this.slider.querySelector('.compare-card');
    if (!card) return this.slider.clientWidth;
    var styles = window.getComputedStyle(this.slider.querySelector('.compare-grid'));
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  };

  Slider.prototype.bind = function () {
    var self = this;
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.slider.scrollBy({ left: -self.step(), behavior: 'smooth' });
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.slider.scrollBy({ left: self.step(), behavior: 'smooth' });
      });
    }
    this.slider.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.debounce(this.layout.bind(this), 150));
  };

  Slider.prototype.layout = function () {
    var scrollable = this.slider.scrollWidth - this.slider.clientWidth > 2;
    this.carousel.classList.toggle('is-scrollable', scrollable);
    this.carousel.setAttribute('data-arrows', String(scrollable && this.showArrows));

    // Build dots (page-based).
    this.dotsWrap.innerHTML = '';
    if (scrollable && this.showDots) {
      this.pageCount = Math.max(1, Math.ceil(this.slider.scrollWidth / this.slider.clientWidth));
      for (var i = 0; i < this.pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'compare-dots__dot';
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.dataset.page = i;
        dot.addEventListener('click', this.goToPage.bind(this, i));
        this.dotsWrap.appendChild(dot);
      }
      this.dotsWrap.setAttribute('data-dots', 'true');
      this.dotsWrap.classList.add('is-active');
    } else {
      this.dotsWrap.classList.remove('is-active');
      this.dotsWrap.setAttribute('data-dots', 'false');
    }
    this.onScroll();
  };

  Slider.prototype.goToPage = function (i) {
    this.slider.scrollTo({ left: i * this.slider.clientWidth, behavior: 'smooth' });
  };

  Slider.prototype.onScroll = function () {
    var max = this.slider.scrollWidth - this.slider.clientWidth;
    var x = this.slider.scrollLeft;
    if (this.prevBtn) this.prevBtn.disabled = x <= 2;
    if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;

    var dots = this.dotsWrap.children;
    if (dots.length) {
      var active = Math.round(x / this.slider.clientWidth);
      if (active > dots.length - 1) active = dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === active);
      }
    }
  };

  Slider.prototype.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  };

  /* ---------- Init ---------- */
  var popups = {};

  function initSection(section) {
    if (section.dataset.cpInit === 'true') return;
    section.dataset.cpInit = 'true';

    new Slider(section);

    section.querySelectorAll('[data-cp-popup]').forEach(function (popup) {
      popups[popup.id] = new VariantPopup(popup);
    });

    // Single-variant direct add
    section.querySelectorAll('.compare-card__foot [data-cp-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id || btn.getAttribute('aria-disabled') === 'true') return;
        addToCart(id, btn).catch(function (err) {
          console.warn('[compare] add to cart failed:', err.message);
        });
      });
    });

    // Open popups
    section.querySelectorAll('[data-cp-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var popup = popups[btn.getAttribute('data-cp-open')];
        if (popup) popup.open(btn);
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.compare-section').forEach(initSection);
  }

  // Global Esc closes any open popup.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Object.keys(popups).forEach(function (id) {
      if (popups[id].popup.classList.contains('is-open')) popups[id].close();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
